// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__FU9gj","checked":"Checkbox_checked__0z61V"};